import React from 'react';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="site-footer" aria-label="Footer">
      <div className="site-footer__inner">
        <div className="site-footer__left">
          <div className="site-footer__brand">PHENNX.IO</div>
          <div className="site-footer__meta">© {new Date().getFullYear()} Phennx. All rights reserved.</div>
          <div className="site-footer__address">
            8027 Cooper Creek Blvd, Suite 110, University Park, FL 34201, USA
          </div>
          <div className="site-footer__badges">
            <img
              className="site-footer__badge"
              src="/hipaa-badge.svg"
              alt="HIPAA Compliant"
              loading="lazy"
            />
            <img
              className="site-footer__badge"
              src="/fda-21cfr-part11-badge.svg"
              alt="FDA 21 CFR Part 11 Compliant"
              loading="lazy"
            />
            <img
              className="site-footer__badge"
              src="/eu-annex-11-badge.svg"
              alt="EU Annex 11 Compliant"
              loading="lazy"
            />
            <img
              className="site-footer__badge"
              src="/ich-gcp-badge.svg"
              alt="ICH GCP Compliant"
              loading="lazy"
            />
          </div>
        </div>

        <div className="site-footer__right">
          <Link className="site-footer__link" to="/about">
            About
          </Link>
          <Link className="site-footer__link" to="/careers">
            Careers
          </Link>
          <Link className="site-footer__link" to="/blog">
            News
          </Link>
          <Link className="site-footer__link" to="/#platform">
            Platform
          </Link>
          <Link className="site-footer__link" to="/#contact">
            Contact
          </Link>
          <Link className="site-footer__link" to="/status">
            Status
          </Link>
          <Link className="site-footer__link site-footer__link--policy" to="/privacy-policy">
            Privacy Policy
          </Link>
          <Link className="site-footer__link site-footer__link--policy" to="/terms-and-conditions">
            Terms &amp; Conditions
          </Link>
          <Link className="site-footer__link site-footer__link--policy" to="/cookie-policy">
            Cookie Policy
          </Link>
          <button
            className="site-footer__link site-footer__link-btn site-footer__link--policy"
            type="button"
            onClick={() => window.dispatchEvent(new Event('cookie-settings:open'))}
          >
            Cookie settings
          </button>
          <Button
            icon="pi pi-linkedin"
            className="social-btn p-button-rounded"
            onClick={() => window.open('https://www.linkedin.com/company/phennx', '_blank', 'noopener,noreferrer')}
            aria-label="LinkedIn (opens in a new tab)"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer;
